module.exports = __webpack_public_path__ + "static/media/06688dff.jpg";